/* Fragrance Luxery – lightweight wishlist (localStorage, no dependencies) */
(function () {
  var KEY = 'lux_wishlist';
  var read = function () { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } };
  var write = function (a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} };
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5c-5.2-3.4-8.5-6.5-8.5-10A4.6 4.6 0 0 1 8 6a4.9 4.9 0 0 1 4 2.2A4.9 4.9 0 0 1 16 6a4.6 4.6 0 0 1 4.5 4.5c0 3.5-3.3 6.6-8.5 10Z"/></svg>';

  function sync(btn) {
    var h = btn.getAttribute('data-lux-wish');
    var on = read().indexOf(h) > -1;
    btn.classList.toggle('is-on', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
  }

  function syncAll() {
    document.querySelectorAll('[data-lux-wish]').forEach(sync);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lux-wish]');
    if (!b || b.hasAttribute('data-lux-wish-remove')) return;
    e.preventDefault();
    e.stopPropagation();
    var h = b.getAttribute('data-lux-wish');
    var a = read();
    var i = a.indexOf(h);
    if (i > -1) { a.splice(i, 1); } else { a.push(h); }
    write(a);
    document.querySelectorAll('[data-lux-wish="' + h + '"]').forEach(sync);
  }, true);

  function initProductPage() {
    var m = location.pathname.match(/\/products\/([a-z0-9\-]+)/);
    var form = document.querySelector('product-form-component');
    if (!m || !form || document.querySelector('.lux-wish--inline')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'lux-wish lux-wish--inline';
    b.setAttribute('data-lux-wish', m[1]);
    b.innerHTML = HEART + '<span>Ajouter aux favoris</span>';
    form.parentNode.insertBefore(b, form.nextSibling);
    sync(b);
  }

  function initWishlistPage() {
    var wrap = document.getElementById('lux-wishlist-root');
    if (!wrap) return;
    var items = read();
    var empty = wrap.querySelector('[data-empty]');
    var grid = wrap.querySelector('[data-grid]');
    if (!items.length) { if (empty) empty.hidden = false; return; }
    items.slice(0, 24).forEach(function (h) {
      fetch('/products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          var d = document.createElement('div');
          d.className = 'lux-wishlist__card';
          var price = (p.price / 100).toFixed(2).replace('.', ',') + ' DH';
          d.innerHTML =
            '<a href="' + p.url + '"><img loading="lazy" src="' + (p.featured_image || '') + '" alt=""><p class="lux-wishlist__title">' + p.title + '</p><p class="lux-wishlist__price">' + price + '</p></a>' +
            '<button type="button" class="lux-btn lux-btn--ghost" data-lux-wish="' + h + '" data-lux-wish-remove>Retirer</button>';
          grid.appendChild(d);
          d.querySelector('[data-lux-wish-remove]').addEventListener('click', function () {
            var a = read();
            var i = a.indexOf(h);
            if (i > -1) { a.splice(i, 1); write(a); }
            d.remove();
            if (!grid.children.length && empty) empty.hidden = false;
          });
        })
        .catch(function () {});
    });
  }

  function init() {
    syncAll();
    initProductPage();
    initWishlistPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', syncAll);
})();
